import PropTypes from 'prop-types';
import React from 'react';

const UnknownEJViewType = ({ type }) => (
  <article className="ta-sm-c display-print">
    {`Journal View not supported for "${type}" transactions.`}
  </article>
);

UnknownEJViewType.defaultProps = {
  type: undefined,
};

UnknownEJViewType.propTypes = {
  type: PropTypes.string,
};

export default UnknownEJViewType;
